import lodashIsEmpty from 'lodash/isEmpty';
import lodashFind from 'lodash/find';
import * as constants from './constants';

export const inspectBrowser = () => {
  const sUsrAg = navigator.userAgent;
  const blockedBrowsers = lodashFind(
    constants.BROWSERS,
    ({ name: browser, allowed }) => sUsrAg.indexOf(browser) > 0 && !allowed,
  );
  return lodashIsEmpty(blockedBrowsers);
};
